export const APP_ROOT_ELEMENT_ID = 'root';

// SENTRY
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_ENV = process.env.REACT_APP_SENTRY_ENVIRONMENT;
export const SENTRY_RELEASE = process.env.REACT_APP_SENTRY_RELEASE;
